import { createBrowserHistory } from 'history'
import ReactDOM from 'react-dom/client'
import React from 'react'
import utcPlugin from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'react-toastify/dist/ReactToastify.css'
import 'lazysizes/plugins/attrchange/ls.attrchange'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import '/node_modules/flag-icons/css/flag-icons.min.css'
import { CustomRouter } from './app/common/CustomRouter'
import reportWebVitals from './reportWebVitals'
import { store, StoreContext } from './app/stores/store'
import './i18n'

dayjs.extend(utcPlugin)

export const history = createBrowserHistory()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StoreContext.Provider value={store}>
    <CustomRouter history={history}>
      <React.Suspense fallback='loading...'>
        <App />
      </React.Suspense>
    </CustomRouter>
  </StoreContext.Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
